module.exports = __webpack_public_path__ + "static/media/location-01-01.c75c2a86.svg";